export default function resolveRule(rule) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var renderer = arguments[2];

  if (rule instanceof Function) {
    return rule(props, renderer);
  }

  return rule;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-bindings/es/resolveRule.js
// module id = 119
// module chunks = 0